module.exports = __webpack_public_path__ + "img/海拉.png";